import { FC } from 'react';
import { getSubdomain } from 'utils/helpers/routing';
import { getUserInfo } from 'utils/auth';

import NotAuthorizedScreen from 'routes/not-authorized';
import InnerWrapper from '../InnerWrapper';
import EditForm from './components/EditForm';

const Screen: FC = () => {
  const isOperator = getSubdomain() === 'operators';
  const isLeaveModuleActive = getUserInfo().featureLeavesIsActive;

  if (isLeaveModuleActive || isOperator) {
    return (
      <InnerWrapper>
        <EditForm />
      </InnerWrapper>
    );
  }
  return <NotAuthorizedScreen />;
};

export default Screen;
